import {Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import {SalesListResponse} from "@portal/api/responses/sales/sales-list-response";
import {fuseAnimations} from "@portal/fuse/animations";
import { MatSort, MatSortHeader } from "@angular/material/sort";
import { Guid } from '@portal/api/guid';
import {MatPaginator} from "@angular/material/paginator";
import {TableDataSource} from "../data-source-connect.datasource";
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { MatIconButton, MatFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatProgressSpinner, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, NgTemplateOutlet, MatIconButton, MatIcon, RouterLink, MatFabButton, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, AsyncPipe]
})
export class TableComponent {
    @Input() dataSource: TableDataSource;
    @Input() columnDefinitions: ColumnDefinition[];
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    expandedElement: SalesListResponse | null;
    @Output() deleteAction = new EventEmitter<Guid>();
    defaultPageSize = 10

    get columnDefs(): string[] {
        return this.columnDefinitions.map(col => col.columnDef);
    }

    deleteClick(id) {
        this.deleteAction.emit(id);
    }
}

export interface ColumnDefinition {
    columnDef: string;
    sort?: boolean;
    header: string;
    cell?: any;
}
